// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n$base-menu-color:hsla(0,0%,100%,.65);\n$base-menu-color-active:#fff;\n$base-menu-background:#001529;\n$base-logo-title-color: #ffffff;\n\n$base-menu-light-color:rgba(0,0,0,.70);\n$base-menu-light-background:#ffffff;\n$base-logo-light-title-color: #001529;\n\n$base-sub-menu-background:#000c17;\n$base-sub-menu-hover:#001528;\n*/\n.el-popup-parent--hidden .fixed-header {\n  padding-right: 17px;\n}", ""]);
// Exports
exports.locals = {
	"menuColor": "#bfcbd9",
	"menuLightColor": "rgba(0, 0, 0, 0.7)",
	"menuColorActive": "#f4f4f5",
	"menuBackground": "#304156",
	"menuLightBackground": "#ffffff",
	"subMenuBackground": "#1f2d3d",
	"subMenuHover": "#001528",
	"sideBarWidth": "0px",
	"logoTitleColor": "#ffffff",
	"logoLightTitleColor": "#001529",
	"theme": "#1890ff"
};
module.exports = exports;
